import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"; // <—

import "./assets/fonts/fonts.css";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { UserRoleProvider } from "./context/UserRoleContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <UserRoleProvider>
          <App />
        </UserRoleProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Register the service worker so app loads offline
serviceWorkerRegistration.register();